import { render, staticRenderFns } from "./setupSms.vue?vue&type=template&id=b9653ebc"
import script from "./setupSms.vue?vue&type=script&lang=js"
export * from "./setupSms.vue?vue&type=script&lang=js"
import style0 from "./setupSms.vue?vue&type=style&index=0&id=b9653ebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports